import { type ReactNode } from 'react';

export interface DetailSectionProps {
  title: string;
  titleRight?: ReactNode;
  divider?: boolean;
  children: ReactNode;
}

export function DetailSection({
  title,
  titleRight,
  divider = true,
  children,
}: DetailSectionProps) {
  return (
    <div style={divider ? {
      borderTop: '1px solid var(--evo-stroke)',
      marginTop: 'var(--evo-space-5)',
      paddingTop: 'var(--evo-space-5)',
    } : undefined}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: titleRight != null ? 'space-between' : 'flex-start',
        marginBottom: 'var(--evo-space-3)',
      }}>
        <span style={{
          fontSize: 'var(--evo-fs-caption)',
          fontWeight: 'var(--evo-fw-medium)',
          letterSpacing: 'var(--evo-ls-caps)',
          color: 'var(--evo-text-muted)',
          textTransform: 'uppercase',
          fontFamily: 'var(--evo-font)',
        }}>
          {title}
        </span>
        {titleRight != null && titleRight}
      </div>
      {children}
    </div>
  );
}
